import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const PlayIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.54 9 8.88 3.46a3.42 3.42 0 0 0-5.13 3v11.12a3.42 3.42 0 0 0 5.13 2.96L18.54 15a3.42 3.42 0 0 0 0-5.92zm-1 4.19-9.66 5.62a1.44 1.44 0 0 1-1.42 0 1.42 1.42 0 0 1-.71-1.23V6.42a1.42 1.42 0 0 1 .71-1.23A1.5 1.5 0 0 1 7.17 5c.248.005.492.07.71.19l9.66 5.58a1.42 1.42 0 0 1 0 2.46z"
    />
  </Icon>
);
